import { cx } from "class-variance-authority"
import { Loader } from "lucide-react"



export const SpinnerModal = ({ label="Please wait..." }) => {
    return (
        <div 
            className={cx(
                "flex items-center gap-[20px] mb-[20px] bg-white",
                "rounded-[8px] md:rounded-[12px] lg:rounded-[16px] p-[24px]"
            )}
        >
            <Loader className="animate-spin w-[24px] h-[60px] text-blue-500" />
            <p className="text-[14px] text-blue-500">{label}</p>
        </div>
    )
}